var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitoring-to-complete"},[_c('p',{staticClass:"monitoring-to-complete__subtitle"},[_vm._v(" "+_vm._s(_vm.$t('monitoringDashboard.toComplete.subtitle'))+" ")]),_c('ToCompleteSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }